class FakeScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this.querySelector('div');
    this.scrollTrack = this.querySelector('.fake-scrollbar-track');
    this.scrollThumb = this.querySelector('.fake-scrollbar-thumb');

    this.dataCenterScroll = this.dataset.centerScroll === '';

    const updatePosition = (e) => {
      const scrollWidth = this.container.scrollWidth;
      const visibleWidth = this.container.clientWidth;
      const scrollLeft = this.container.scrollLeft;

      const maxScroll = scrollWidth - visibleWidth;
      const thumbWidthPx = (visibleWidth / scrollWidth) * visibleWidth;
      const maxThumbMove = visibleWidth - thumbWidthPx;

      const thumbPositionPx = (scrollLeft / maxScroll) * maxThumbMove;

      this.scrollThumb.style.width = `${thumbWidthPx}px`;
      this.scrollThumb.style.transform = `translateX(${thumbPositionPx}px)`;
    };

    this.container.addEventListener('scroll', (e) => updatePosition(e));
    window.addEventListener('resize', (e) => updatePosition(e));

    // init
    this.container.dispatchEvent(new Event('scroll'));

    // center scroll container
    if (this.dataCenterScroll) {
      const scrollWidth = this.container.scrollWidth;
      const clientWidth = this.container.clientWidth;

      this.container.scrollLeft = (scrollWidth - clientWidth) / 2;
    }
  }
}

if (!customElements.get('fake-scroll')) {
  customElements.define('fake-scroll', FakeScroll);
}
